module.exports = {
  ShapeOverlay: {
    PluginName: "Şekil Kaplaması",
    Shape: "Şekil",
    Type: "Tür",
    Color: "Renk",
  },
};
